import { Observable } from 'rxjs';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Injectable } from '@angular/core';

import { AppComfirmComponent } from './app-confirm.component';

interface confirmData {
  title?: string;
  message?: string;
  instructions?: string;
  okText?: string;
  cancelText?: string;
  extraButton?: { text: string };
  width?: string;
}

@Injectable({
  providedIn: 'root'
})
export class AppConfirmService {
  constructor(private dialog: MatDialog) {}

  public confirm(data: confirmData = {}): Observable<any> {
    const dialogWidth = data.width || (data.extraButton ? '600px' : '400px');

    let dialogRef: MatDialogRef<AppComfirmComponent>;
    dialogRef = this.dialog.open(AppComfirmComponent, {
      width: dialogWidth,
      panelClass: 'ebo-confirm-dialog',
      disableClose: true,
      data: {
        title: data.title,
        message: data.message,
        instructions: data.instructions,
        okText: data.okText,
        cancelText: data.cancelText,
        extraButton: data.extraButton
      }
    });
    return dialogRef.afterClosed();
  }
}
